import React, { Component } from 'react';
import MainText from './MainText';
import { connect } from 'react-redux';
import Toolbar from './Toolbar';

class TextOnlyLayout extends Component {
    render() {
        return (
            <div className="layout-page">
                {/* this scene has a title, some action buttons, stored in an array, with type data, visual elements (how many? what type?) stored in an array, with type data, and data about next available scenes, stored in an array */}
                <div className="flex-box flex-center">

                    <div className="column-lg-10 column-md-12 column-sm-12">
                    {this.props.activeScene.title !== null && <h2><span className="title">{this.props.activeScene.title}</span></h2>} 
                    </div>
                </div>
                <div className="flex-box flex-center">
                {this.props.activeScene.text && this.props.activeScene.title !== null && <div className="column-lg-10 column-md-12 column-sm-12 text-spotlight text-blue">
                        {this.props.activeScene.text.map((text, i) => {
                            return (
                                <MainText className={`text-div`} text={text} key={i}/>
                           );
                        })}
                    </div>}
                    {this.props.activeScene.text && this.props.activeScene.title === null && <div className="column-lg-10 column-md-12 column-sm-12 text-spotlight text-shadow">
                        {this.props.activeScene.text.map((text, i) => {
                            return (
                                <MainText className={`text-div text-div-light`} text={text} key={i}/>
                           );
                        })}
                    </div>}
                    </div> 
              
                <Toolbar history={this.props.history}/>
            </div>

        );
    }
}
const mapStateToProps = state => ({
    activeScene: state.activeScene
})
export default connect(mapStateToProps)(TextOnlyLayout);